import { CommonModule } from '@angular/common';
import { Component, Input, signal } from '@angular/core';
import { BlogCard } from '../../../../../shared/components/blog-card/blog-card';
import { IBlogPostMeta } from '../../../../../shared/interfaces/blog-post.interface';

@Component({
  selector: 'app-post-carousel',
  standalone: true,
  imports: [CommonModule, BlogCard],
  templateUrl: './post-carousel.html',
  styleUrl: './post-carousel.scss'
})
export class PostCarousel {

  @Input()
  public postsRaw: IBlogPostMeta[] = [];

  protected fromPost = 0;
  protected toPost = 3;

  protected showPosts = signal(true);

  private carouselTimeout = 4000;
  private timer: any;

  protected carouselSteps = [
    { value: 1, active: true },
    { value: 2, active: false },
    { value: 3, active: false },
    { value: 4, active: false },
    { value: 5, active: false },
    { value: 6, active: false }
  ];

  constructor() { }

  ngOnInit() {
    this.startCarouselAutoplay();
  }

  ngOnDestroy() {
    this.clearCarouselTimer();
  }

  private startCarouselAutoplay() {
    this.clearCarouselTimer();
    this.timer = setTimeout(() => {
      this.showPosts.update((show) => !show);
      this.nextStep();
      this.startCarouselAutoplay();

    }, this.carouselTimeout);
  }

  private clearCarouselTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  nextStep() {
    setTimeout(() => {
      this.showPosts.update((show) => !show);
      const current = this.activeStep;
      const next = current === 6 ? 1 : current + 1;

      this.activateCarousel(next);
    }, 50);
  }

  activateCarousel(value: number) {
    this.carouselSteps = this.carouselSteps.map(step => ({
      ...step,
      active: step.value === value
    }));
    this.updateFromTo();
  }

  updateFromTo() {
    this.fromPost = this.activeStep - 1;
    this.toPost = this.activeStep + 2;
  }

  get activeStep(): number {
    return this.carouselSteps.find(step => step.active)?.value || 1;
  }

  get posts(): IBlogPostMeta[] {
    return this.postsRaw.slice(this.fromPost, this.toPost);
  }
}
